export default __webpack_public_path__ + "static/media/misc-pantry2-480w.c1233e1f.png";